<template>
<div class="lending-term">
  <LendingTermGeneric
    v-if="companyTerms === 'generic'"
    :customer="customer"
    :ticket="ticket"
    :config="config"
  />
  <LendingTermEnelCe
    v-if="`${state}` === 'CE' && companyTerms === 'enel'"
    :customer="customer"
    :ticket="ticket"
    :config="config"
  />

  <LendingTermEnelGo
    v-if="`${state}` === 'GO' && companyTerms === 'enel'"
    :customer="customer"
    :ticket="ticket"
    :config="config"
  />
  <div v-if="state === 'MA' && companyTerms === 'cemar'">
    <lending-term-cemar
      :customer="customer"
      :ticket="ticket"
      :config="config"
      :manufacturer="manufacturer"
    />
    <div class="page-break"></div>
    <lending-term-cemar
      :customer="customer"
      :ticket="ticket"
      :config="config"
      :manufacturer="manufacturer"
    />
  </div>

  <lending-term-iasc-ma
    v-if="`${state}` === 'MA' && companyTerms === 'iasc'"
    :customer="customer"
    :ticket="ticket"
    :config="config"
  />

  <lending-term-iasc-pi
    v-if="`${state}` === 'PI' && companyTerms === 'iasc'"
    :customer="customer"
    :ticket="ticket"
    :config="config"
  />
  <lending-term-equatorial-pi
    v-if="`${state}` === 'PI' && companyTerms === 'equatorial'"
    :customer="customer"
    :ticket="ticket"
    :config="config"
  />

  <lending-term-iasc-al
    v-if="`${state}` === 'AL' && companyTerms === 'iasc'"
    :customer="customer"
    :ticket="ticket"
    :config="config"
  />

  <lending-term-energisa-pb
    v-if="`${state}` === 'PB' && companyTerms === 'energisa-paraiba'"
    :customer="customer"
    :ticket="ticket"
    :config="config"
  />

  <lending-term-energisa-borborema-pb
    v-if="`${state}` === 'PB' && companyTerms === 'energisa-borborema'"
    :customer="customer"
    :ticket="ticket"
    :config="config"
  />

  <LendingTermCelpa
    v-if="`${state}` === 'PA' && companyTerms === 'celpa'"
    :customer="customer"
    :ticket="ticket"
    :config="config"
  />
  <LendingTermCelpaJurunas
    v-if="`${state}` === 'PA' && companyTerms === 'celpa-jurunas'"
    :customer="customer"
    :ticket="ticket"
    :config="config"
  />
</div>
</template>

<script>
import LendingTermEnelCe from './EnelCe/LendingTermEnelCe'
import LendingTermEnelGo from './EnelGo/LendingTermEnelGo'
import LendingTermCemar from './Cemar/LendingTermCemar'
import LendingTermIascPi from './IascPi/LendingTermIasc'
import LendingTermIascMa from './IascMa/LendingTermIascMa'
import LendingTermIascAl from './IascAl/LendingTermIasc'
import LendingTermEnergisaPb from './EnergisaPb/LendingTermEnergisaPb'
import LendingTermEnergisaBorboremaPb from './EnergisaBorboremaPb/LendingTermEnergisaBorboremaPb'
import LendingTermCelpa from './Celpa/LendingTermCelpa'
import LendingTermEquatorialPi from './EquatorialPi/LendingTermEquatorialPi'
import LendingTermCelpaJurunas from './CelpaJurunas/LendingTermCelpaJurunas'
import LendingTermGeneric from '../../../components/Trg/Terms/LendingTermGeneric'
export default {
  name: 'lending-term',
  components: {
    LendingTermGeneric,
    LendingTermCelpaJurunas,
    LendingTermEquatorialPi,
    LendingTermEnelCe,
    LendingTermEnelGo,
    LendingTermCemar,
    LendingTermIascPi,
    LendingTermIascMa,
    LendingTermIascAl,
    LendingTermEnergisaPb,
    LendingTermEnergisaBorboremaPb,
    LendingTermCelpa
  },
  props: {
    ticket: {
      required: true
    },
    config: {
      required: true
    },
    loading: {
      required: true
    },
    state: {
      required: true
    },
    customer: {
      required: true
    },
    manufacturer: {
      required: true
    },
    companyTerms: {
      required: true
    }
  }
}
</script>

<style>
  @media print {
    .page-break {
      page-break-after: always;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Documents/Terms/LendingTerm.vue